import { makeStyles, shorthands } from '@fluentui/react-components';

export const useVideoCardStyles = makeStyles({
  videoCardListItem: {
    marginRight: '16px',
  },
  videoCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '194px !important',
    height: '220px !important',
    pointerEvents: 'auto',
  },
  videoCardThumbnail: {
    width: '194px !important',
    height: '160px !important',
    objectFit: 'cover',
    ...shorthands.overflow('hidden'),
  },
  videoCardPreviewPlaceholder: {
    width: '194px !important',
    height: '160px !important',
    backgroundColor: '#F5F5F5',
    ...shorthands.overflow('hidden'),
  },
  videoCardFooter: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    height: '60px !important',
    width: '194px !important',
    paddingLeft: '15px !important',
  },
  videoCardFooterContent: {
    display: 'flex',
    rowGap: '0px !important',
    paddingBottom: '2px !important',
    flexDirection: 'column',
    alignItems: 'flex-start',
    ...shorthands.gap('4px'),
  },
  videoIconAndName: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.gap('4px'),
  },
  videoName: {
    width: '142px',
    ...shorthands.overflow('hidden'),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  videoCardCaption: {
    paddingBottom: '5px !important',
    paddingLeft: '2px !important',
  },
});
